export const AUTHENTICATION_STATUS = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAIL: 'LOGIN_FAIL',
    LOGOUT: 'LOGOUT'
};

export const USER_KEY = "user";
export const ACCESS_TOKEN_KEY = "token";